// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_e71e0357","item":"rdg_47275a6d"};